import React, { useEffect, useState, useMemo } from 'react';
import Paper from '@mui/material/Paper';
import { ADMIN_CREATION } from '../../../constants/DashboardConstants';
import WarningTriangle from '../../../../public/assets/img/warning.svg';
import './createadmin.scss';
import { useDispatch, useSelector } from 'react-redux';
import { Card, CardContent, InputAdornment, TextField, Grid } from '@mui/material';
import { CREATE_ACCOUNT, CREATE_ADMIN_TITLE } from '../../../constants/buttonConstants';
import { EMAIL_HINT_711, USERNAME_HINT } from '../../../constants/settingsPageConstants';
import { validateEmail, validateUserName } from '../../../shared/utils/format.helpers';
import { clearCreateAdminRequestResponse, createAdminRequest } from '../../../redux/actions/accountServiceAction';
import { createAdminAccountResponseSaga } from '../../../redux/saga/accountServiceSelector';
import { loadingInProgress } from '../../../redux/actions/loginServiceAction';
import CustomStatusPage from '../../../shared/pages/custom.status';
import MerchantAccountDetailsSubCard from '../../../shared/cards/MerchantAccountDetailsSubCard/MerchantAccountDetailsSubCard';
import { Checkmate } from '../../../constants/Admin/MerchantAccountConstants';
import MerchantAccountDetailsCard from '../../../shared/cards/MerchantAccountDetailsCard/MerchantAccountDetailsCard';

const CreateAdminForm = () => {
	const [businessEmailError, setbusinessEmailError] = useState(false);
	const [usernameError, setUsernameError] = useState(false);
	const [formValid, setformValid] = useState(false);
	const [formData, setformData] = useState({
		fields: {
		businessEmail: '',
		username: '',
		confirmpassword: '',
		},
		errors: {},
	});
	const [errormsg, seterrormsg]= useState('');
	const [businessEmailIcon, setbusinessEmailIcon] = useState(null);
	const [usernameErrorIcon, setUsernameErrorIcon] = useState(false);
	const dispatch = useDispatch();
	const createAdminAccountResponse = useSelector(createAdminAccountResponseSaga);
	const [statusComponent, setStatusComponent] = useState(null);

	useEffect(() => {
		// console.log('RES ',createAdminAccountResponse)
		if (createAdminAccountResponse) {
		dispatch(loadingInProgress(false))
		if (createAdminAccountResponse?.msg) {
			if (createAdminAccountResponse?.details?.data?.message === 'Username/Email already taken. Please try another.' ) {
				seterrormsg(createAdminAccountResponse?.details?.data?.message);
				setformValid(false);
				setStatusComponent(null);
			} else  if (createAdminAccountResponse.details?.data?.message) {
			setStatusComponent(<CustomStatusPage statusIndicator='User_Admin_Creation_Failed' />)
			} else if (createAdminAccountResponse.details?.code === 'ECONNABORTED') {
			setStatusComponent(<CustomStatusPage statusIndicator='User_Admin_Creation_Failed' />)
			} else {
			setStatusComponent(<CustomStatusPage statusIndicator='User_Admin_Creation_Failed' />)
			}
		} else {
			setStatusComponent(<CustomStatusPage statusIndicator='User_Admin_Created' />);
		}
		}
		else{
		setStatusComponent(null);
		}
	}, [createAdminAccountResponse]);

	useEffect(()=>{
		dispatch(clearCreateAdminRequestResponse());
		seterrormsg('');
	},[])
  
	const createAdminHandler = (e) => {
		e.preventDefault();
		if(formValid){
		dispatch(loadingInProgress(true))
		dispatch(
			createAdminRequest(
			formData.fields.username,
			formData.fields.businessEmail
			)
		);
		}
	};
	const handleChange = (e) => {
		let fields = formData.fields;
		let errors = formData.errors;
		fields[e.target.id] = e.target.value;

		if (e.target.id === 'businessEmail') {
			seterrormsg('');
		if (
			formData.fields.businessEmail === '' ||
			(formData.fields.businessEmail && (!validateEmail(formData.fields.businessEmail) || !formData.fields.businessEmail.endsWith('@7-11.com')))
		) {
			setformValid(false);
			setbusinessEmailError(true);
			setbusinessEmailIcon(WarningTriangle);
			errors[e.target.id] = EMAIL_HINT_711;
		} else {
			setformValid(true);
			setbusinessEmailError(false);
			setbusinessEmailIcon(null);
			delete errors[e.target.id];
		}
		}

		if (e.target.id === 'username') {
			seterrormsg('');
		if (
			formData.fields.username === '' ||
			(formData.fields.username !== '' &&
			!validateUserName(formData.fields.username))
		) {
			setformValid(false);
			setUsernameError(true);
			setUsernameErrorIcon(WarningTriangle);
			errors[e.target.id] = USERNAME_HINT;
		} else {
			setformValid(true);
			setUsernameError(false);
			setUsernameErrorIcon(null);
			delete errors[e.target.id];
		}
		}

		if (
		formData.fields.username === '' ||
		(formData.fields.username !== '' &&
			!validateUserName(formData.fields.username)) ||
		formData.fields.businessEmail === '' ||
		(formData.fields.businessEmail &&
			!validateEmail(formData.fields.businessEmail))
		) {
		setformValid(false);
		}
		setformData({ ...formData });
	};

	return (
		<>
			{statusComponent? statusComponent:
				<>
					<div className='iacm-container' data-testid='admin-create-id'>
						<Paper className='page-header'>
						<h4 className='title-class'>
							{ADMIN_CREATION}
						</h4>
						</Paper>
					</div>
					<div className='iacm-container-body'>
						<Card variant='outlined' className='iacm-container2'>
							<div className='create-admin-title'>
								<p className='marginb8'>{CREATE_ADMIN_TITLE}</p>
							</div>
							<CardContent className='form-activation-container'>
								<form autoComplete='off' onSubmit={createAdminHandler}>
									<Grid container spacing={2} sx={{padding: '24px 16px 0px 16px'}}>
										<Grid item xs={6}>
											<TextField
												id='businessEmail'
												data-testid='businessEmail'
												label='Business Email'
												onChange={handleChange}
												required
												variant='outlined'
												color='secondary'
												type='text'
												aria-label='Business Email'
												error={businessEmailError}
												helperText={formData.errors?.businessEmail}
												fullWidth
												sx={{ mb: 3 }}
												inputProps={{ fontSize: '26px' }}
												InputProps={{
												endAdornment: (
													<InputAdornment position='end'>
													{formData.errors?.businessEmail ? (
														<img src={businessEmailIcon} className='error-icon' />
													) : null}
													</InputAdornment>
												),
												}}
											/>
										</Grid>
										<Grid item xs={6}>
											<TextField
												id='username'
												data-testid='username'
												label='Username'
												onChange={handleChange}
												required
												variant='outlined'
												color='secondary'
												type='text'
												aria-label='Username'
												error={usernameError}
												helperText={formData.errors?.username}
												fullWidth
												sx={{ mb: 3 }}
												inputProps={{ fontSize: '26px' }}
												InputProps={{
												endAdornment: (
													<InputAdornment position='end'>
													{formData.errors?.username ? (
														<img src={usernameErrorIcon} className='error-icon' />
													) : null}
													</InputAdornment>
												),
												}}
											/>
										</Grid>
									</Grid>
									<div className='subcarddetails'>
										<MerchantAccountDetailsSubCard SUBHEADER2={Checkmate.SUBHEADER2} HEADER_TEXT2={Checkmate.HEADER_TEXT2} />
									</div>
									{errormsg && <div className='error-msg'>{errormsg}</div> }
									<div className='form-activation-container-button'>
										<button
										className='form-activation-container-button--primaryButton'
										aria-label='Submit Reset Password'
										data-testid='submitButton'
										disabled={!formValid}
										variant='outlined'
										type='submit'
										>
										{CREATE_ACCOUNT}
										</button>
									</div>
								</form>
							</CardContent>
						</Card>
						<MerchantAccountDetailsCard selectedAggregator='createAdmin' className='test123'/>
					</div>
				</>
			}
		</>
	);
};

export default CreateAdminForm;
